import React, { Fragment } from 'react';
import type { InspirationalGridProps } from 'Components/widgets/inspirational-grid/InspirationalGrid';
import {
  getContainerStyles,
  MAINSTAGE_CONTAINER_RATIO,
  VERTICAL_RATIO,
} from 'Components/widgets/inspirational-grid/InspirationalGrid';
import { InspirationalDescription } from 'Components/widgets/inspirational-grid/InspirationalDescription';
import { InspirationalPicture } from 'Components/widgets/inspirational-grid/InspirationalPicture';
import { classnames } from 'Utils/classnames/classnames.utils';
export const InspirationalGridMainStage = ({
  description,
  pictures,
  subtitle,
  title,
}: InspirationalGridProps) => {
  const containerStyles = getContainerStyles(MAINSTAGE_CONTAINER_RATIO);
  const leftPanelContentStyles = 'w-[calc(280/1180*100%)]';
  const centerPanelContentStyles = 'w-[calc(355/1180*100%)]';
  const rightPanelContentStyles = leftPanelContentStyles;
  const margin = 'my-0 mr-[calc(20/1180*100%)] ml-auto';
  const shouldDisplayInlineDescription = pictures.length < 3;
  const offsetIndex = shouldDisplayInlineDescription ? 1 : 0;
  const editorialZone = (
    <InspirationalDescription
      title={title}
      subtitle={subtitle}
      description={description}
      centered={!shouldDisplayInlineDescription}
    />
  );
  return (
    <Fragment>
      {!shouldDisplayInlineDescription && editorialZone}
      <div className="relative h-0 w-full" style={containerStyles}>
        <div className="absolute inset-0 flex">
          <div className={classnames('mr-auto flex items-center', leftPanelContentStyles)}>
            {shouldDisplayInlineDescription ? (
              editorialZone
            ) : (
              <InspirationalPicture
                ratioDisplay={280 / 1180}
                ratioKey={VERTICAL_RATIO}
                {...pictures[0 - offsetIndex]}
                index={1}
              />
            )}
          </div>
          <div className={classnames('ml-auto flex', centerPanelContentStyles, margin)}>
            <InspirationalPicture
              ratioDisplay={355 / 1180}
              ratioKey={VERTICAL_RATIO}
              {...pictures[1 - offsetIndex]}
              index={2}
            />
          </div>
          <div className={classnames('flex items-center', rightPanelContentStyles)}>
            <InspirationalPicture
              ratioDisplay={280 / 1180}
              ratioKey={VERTICAL_RATIO}
              {...pictures[2 - offsetIndex]}
              index={3}
            />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
